import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, CardHeader, Container } from 'reactstrap';
import '../../../styles/report.scss';
import { getReports } from '../../../redux/methods/reports';
import useFetch from '../../../hooks/useFetch';
import { connect } from 'react-redux';
import TableGenerator from '../../../components/generators/TableGenerator';
import { useIntl } from 'react-intl';

export function ReportListPage({ getReports })
{
    const intl = useIntl();
    const translations = intl.messages.reports;
    const translation = (section, key) => translations?.[section]?.[key] ?? key;
    const [reports] = useFetch(getReports, null, []);
    const reportLink = item => <Link to={`/reports/${item.id}`}>{translation('types', item.type)}</Link>;
    const columns =
    [
        { header: translation('headers', 'Id'), value: 'id' },
        { header: translation('headers', 'Type'), value: 'type', type: 'custom', customCell: reportLink },
        { header: translation('headers', 'Created'), value: 'createdAt', type: 'date', withTime: true }
    ];
    const element =
    <Container fluid>
        <Card>
            <CardHeader>{translation('headers', 'Report List')}</CardHeader>
            <CardBody>
                <TableGenerator items={reports} translations={translations} columns={columns} />
            </CardBody>
        </Card>
    </Container>;
    return element;
}

const mapDispatch =
{
    getReports
};

export default connect(() => ({}), mapDispatch)(ReportListPage);